<template>
    <div
        class="AdvertisingMster_wrap"
        v-if="isOpenDialog"
        id="AdvertisingMster_wrap"
        clstag="jr|keycount|8530052_0118|03_point"
        @click="AdvertisingMsterMaster"
    >
        <div class="AdvertisingMster_inner_wrap">
            <div
                class="AdvertisingMster_inner_img"
                @click="enterAdvertEvent"
                clstag="jr|keycount|8530052_0118|01_point"
            ><img
                    :src="imgUrl"
                    alt=""
                /></div>
            <div
                class="AdvertisingMster_btn_close"
                @click="closeAdvert"
                clstag="jr|keycount|8530052_0118|02_point"
            >
                <img
                    src="https://m.360buyimg.com/jfe/jfs/t1/22576/13/8052/2548/5c73921cE4626769b/1916146c2bbfb502.png"
                    alt=""
                >
            </div>
        </div>
    </div>
</template>
<style  lang="scss">
@import '@/scss/mixin.scss';
.AdvertisingMster_wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 200;
}
.AdvertisingMster_inner_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.AdvertisingMster_inner_img {
    margin-bottom: $rem40;
}
.AdvertisingMster_btn_close {
    width: $rem100;
    height: $rem100;
    border-radius: 100%;
    overflow: hidden;
}
.AdvertisingMster_btn_close img {
    width: $rem100;
    height: $rem100;
}
.AdvertisingMster_inner_img {
    width: $rem600;
    height: $rem800;
    overflow: hidden;
}
.AdvertisingMster_inner_img img {
    width: 100%;
    height: auto;
}
</style>
<script>
import request from '@/util/request';
import { isMiniProgram } from '@/util/common';
export default {
    name: 'AdvertisingMsterDialog',
    data() {
        return {
            getSyXcObject: {},
            isOpenDialog: false,
            imgUrl: '',
            point: '',
            isLogin: true
        };
    },
    created() {
        this.isOpenDialogEvent();
    },
    methods: {
        formatDate(date) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return year + '/' + month + '/' + day;
        },
        isOpenDialogEvent() {
            request.getSyXc({
                data: {
                    deviceId: $.device.deviceId ? $.device.deviceId : ''
                },
                success: resData => {
                    if (resData && resData.btSyXc && JSON.stringify(resData.btSyXc) != '{}') {
                        this.getSyXcObject = resData.btSyXc;
                        if (resData.btSyXc && resData.btSyXc.point) {
                            this.point = resData.btSyXc.point;
                        }
                        if (resData.btSyXc.isLogin) {
                            this.isOpenDialog = true;
                            this.imgUrl = resData.btSyXc.imgUrl;
                            this.stop();
                        } else {
                            if (localStorage.getItem('HASOVERTIMER') == this.formatDate(new Date())) {
                                this.isOpenDialog = false;
                                this.imgUrl = '';
                                return;
                            } else {
                                localStorage.setItem('HASOVERTIMER', this.formatDate(new Date()));
                                this.isOpenDialog = true;
                                this.stop();
                                this.imgUrl = resData.btSyXc.imgUrl;
                            }
                            // let time = new Date().getTime();
                            // let data = new Date(new Date().toLocaleDateString()).getTime();
                            // if (!localStorage.getItem('HASOVERTIMER')) {
                            //     localStorage.setItem('HASOVERTIMER', time);
                            //     this.isOpenDialog = true;
                            //     this.imgUrl = resData.btSyXc.imgUrl;
                            //     console.log('99');
                            // }
                            // if (localStorage.getItem('HASOVERTIMER') && Number(localStorage.getItem('HASOVERTIMER')) < Number(data)) {
                            //     localStorage.removeItem('HASOVERTIMER');
                            //     this.isOpenDialog = true;
                            //     this.imgUrl = resData.btSyXc.imgUrl;
                            //     console.log('666');
                            // }
                            // if (localStorage.getItem('HASOVERTIMER') && Number(localStorage.getItem('HASOVERTIMER')) >= Number(data)) {
                            //     this.isOpenDialog = false;
                            //     this.imgUrl = '';
                            //     console.log('7777');
                            // }
                        }
                    } else {
                        this.isOpenDialog = false;
                    }
                },
                afterError: () => {}
            });
        },
        //进入广告
        enterAdvertEvent() {
            event.stopPropagation();
            let jumpUrl = '';
            if ($.device.jdapp) {
                jumpUrl = this.getSyXcObject.jdappUrl || '';
            } else if ($.device.jdjr) {
                jumpUrl = this.getSyXcObject.jrappUrl || '';
            } else if (isMiniProgram()) {
                jumpUrl = this.getSyXcObject.xcxUrl || '';
            } else {
                jumpUrl = this.getSyXcObject.wqUrl || '';
            }
            if (jumpUrl) {
                this.isOpenDialog = false;
                this.move();
                window.location.href = jumpUrl;
            } else {
                this.closeAdvert();
            }
        },
        AdvertisingMsterMaster() {
            event.stopPropagation();
        },
        closeAdvert() {
            this.isOpenDialog = false;
            this.move();
        },
        mo(e) {
            e.stopPropagation();
            e.preventDefault();
        },
        /***添加滑动限制***/
        stop() {
            $('body').css({ overflow: 'hidden' });
            $('html').css({ overflow: 'hidden' });
            document.body.addEventListener('touchmove', this.mo, { passive: false, capture: true });
        },
        /***取消滑动限制***/
        move() {
            $('body').css({ overflow: 'hidden', overflowY: 'scroll' });
            $('html').css({ overflow: 'visible' });
            document.body.removeEventListener('touchmove', this.mo, { capture: true });
        }
    }
};
</script>

